import { Component, computed, effect, inject, input } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormFieldService } from '../../services/form-field/form-field.service';
import { FormFieldLabelsConfig, FormFieldType } from '../../form-field.types';
import { TextFormFieldComponent } from '../form-fields/text-form-field/text-form-field.component';
import { AutocompleteFormFieldComponent } from '../form-fields/autocomplete-form-field/autocomplete-form-field.component';
import { SelectFormFieldComponent } from '../form-fields/select-form-field/select-form-field.component';
import { CheckboxFormFieldComponent } from '../form-fields/checkbox-form-field/checkbox-form-field.component';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { DatePickerFormFieldComponent } from '../form-fields/date-picker-form-field/date-picker-form-field.component';
import { KeyUsageFormFieldComponent } from '../form-fields/key-usage-form-field/key-usage-form-field.component';
import { ExtendedKeyUsageFormFieldComponent } from '../form-fields/extended-key-usage-form-field/extended-key-usage-form-field.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-form-field',
  imports: [
    MatTooltipModule,
    TextFormFieldComponent,
    SelectFormFieldComponent,
    AutocompleteFormFieldComponent,
    CheckboxFormFieldComponent,
    DatePickerFormFieldComponent,
    KeyUsageFormFieldComponent,
    ExtendedKeyUsageFormFieldComponent,
  ],
  templateUrl: './form-field.component.html',
  styleUrl: './form-field.component.scss',
})
export class FormFieldComponent {
  private formFieldService = inject(FormFieldService);

  name = input('');
  disabledTooltipText = input('');
  errorStateMatcher = input<ErrorStateMatcher>({
    isErrorState: control => !!(control?.touched && control?.errors),
  });
  path = input<string | (string | number)[]>();
  options = input<FormFieldLabelsConfig['options']>();
  pathStr = computed(() => {
    const path = this.path();
    if (typeof path === 'string') {
      return path;
    }
    if (Array.isArray(path)) {
      return path.join('.');
    }
    return undefined;
  });
  config = toSignal(
    this.formFieldService.formFieldConfig(toObservable(this.name)),
  );
  control = this.formFieldService.control(this.name, this.path);
  FormFieldType = FormFieldType;

  private updateLabelsEffect = () => {
    const options = this.options();
    const name = this.name();
    if (name && options) {
      this.formFieldService.updateControlLabels(name, { options });
    }
  };

  constructor() {
    effect(this.updateLabelsEffect);
  }
}
